import React from 'react'
import request from 'request-promise'
import LangAccessCodes from '../../LangAccessCodes'
import Auth from '../../Auth'
import Student from '../../Student'
import { Button } from '@material-ui/core'

const { REACT_APP_API_URI } = process.env

export default ({ styles }) => {
    const { langAccessCodes = {}, setLangAccessCodes } = LangAccessCodes.useContainer()
    const { token } = Auth.useContainer()
    const {
        student: { emailEcole },
    } = Student.useContainer()
    const [fetchingLangAccessCodes, setFetchingLangAccessCodes] = React.useState({ oxford: false, altissia: false })
    const requestLangAccessCode = async (lang) => {
        const key = 'oxford' // = lang === 'en' ? 'oxford' : 'altissia'

        setFetchingLangAccessCodes({ ...fetchingLangAccessCodes, [key]: true })

        try {
            const result = await request({
                uri: `${REACT_APP_API_URI}/fetch-codes`,
                method: 'POST',
                body: { lang },
                json: true,
                headers: { authorization: `Bearer ${token}` },
            });

            console.log(result);

            setLangAccessCodes({
                ...langAccessCodes,
                [key]: { ...result },
            })

            setFetchingLangAccessCodes({ ...fetchingLangAccessCodes, [key]: false })
        } catch (e) {
            console.log(e.error);
            if (e.statusCode === 500 && e.error) {
                if (e.error.error.includes('It seems that we ran out of available access codes for this test')) {
                    alert("Nous n'avons plus de code à fournir pour le moment. Veuillez réessayer d'ici une ou deux heures.")
                }

                if (e.error.error.includes('Codes already reserved for this user')) {
                    alert("Des codes vous ont déjà été attribués. Si vous ne les voyez pas, veuillez contacter le support informatique.")
                }

            } else {
                alert("Une erreur s'est produite lors de la récupération des codes. Veuillez réessayer plus tard.")
            }
            console.log(e);
        }

    }

    return langAccessCodes.oxford ? (
        <>
            <ul className={styles.langAccessCodes}>
                <li>
                    <span>Student name:</span> {langAccessCodes.oxford.studentName}
                </li>
                <li>
                    <span>Username:</span> {langAccessCodes.oxford.username}
                </li>
                <li>
                    <span>Password:</span> {langAccessCodes.oxford.password}
                </li>
                <li>
                    <span>Organisation ID:</span> {langAccessCodes.oxford.orgID}
                </li>
                <li>
                    <span>Email à utiliser:</span> {emailEcole}
                </li>
            </ul>
            <p>
                <strong>Important :</strong> après l'authentification, il vous sera demandé de compléter vos informations personnelles (First name, Last name, Email). À cette étape, il faudra impérativement utiliser votre
                adresse e-mail École ({emailEcole}).
            </p>
        </>
    ) : (
        <Button
            variant="contained"
            size="small"
            onClick={() => requestLangAccessCode('en')}
            disabled={fetchingLangAccessCodes.oxford}
        >
            Obtenir les informations d'accès
        </Button>
    )
}
